import React, {Component} from "react"
import styled from "styled-components"

import {H4} from "@irati/ui/src//Typography/Heading"
import {Grid as GridBase, Row, Col} from "react-bootstrap"
import Banner from "@irati/ui/src/Banner"
import Modal from "@irati/ui/src/Modal"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import RewardDetail, {RewardSummary} from "@irati-web/reward/src/components/Detail"
import Card from "@irati/ui/src/Layout/Card"
import {Reward} from "@irati/types"
import Markdown from "@irati/ui/src/Markdown"

const Grid = styled(GridBase)`
  margin-top: -200px;
`
interface State {
  isTermsAndConditionsShown: boolean
}

interface Props {
  reward: Reward
}

class RewardDetailContainer extends Component<Props, State> {
  state = {
    isTermsAndConditionsShown: false
  }

  showTermsAndConditions = () => {
    this.setState({
      isTermsAndConditionsShown: true
    })
  }

  hideTermsAndConditions = () => {
    this.setState({
      isTermsAndConditionsShown: false
    })
  }

  render() {
    const {reward} = this.props
    const {isTermsAndConditionsShown} = this.state
    return (
      <>
        <Banner backgroundColor="transparent" bannerImg={reward.bannerImage} />
        <Grid>
          <Row>
            <Col md={8} sm={12}>
              <Card large>
                <RewardDetail reward={reward} />
              </Card>
            </Col>

            <Col md={4}>
              <Card>
                <RewardSummary reward={reward} onClickTermsAndConditions={this.showTermsAndConditions} />
              </Card>
            </Col>
          </Row>
        </Grid>

        {reward.termsAndConditions && (
          <Modal show={isTermsAndConditionsShown} onHide={this.hideTermsAndConditions}>
            <H4>
              <FormattedMessage id="reward.detail.termsAndConditions.title" />
            </H4>
            <Markdown source={reward.termsAndConditions} />
          </Modal>
        )}
      </>
    )
  }
}

export default injectIntl(RewardDetailContainer)
